export const  TipoRecursoCameEnum  = Object.freeze({
    DOCUMENTO: 1,
    MOVIMIENTO_DOC: 2,
})